import React, { useContext } from "react";

import { ScoreType } from "@common/constants/ScoreType";
import { ResultsContext, ResultsEventContext } from "@state/context/results";
import range from "lodash/range";

export function ScoreRenderer() {
	const result = useContext(ResultsContext);

	if (result.scoreType === ScoreType.FTONLY) {
		return <FullTimeScore />;
	}
	return (
		<>
			<FullTimeScore />
			<ScorePerPeriod />
			<HalfTimeScore />
			<OverTimeScore />
			<OverTimeEmpty />
		</>
	);
}

const FullTimeScore = function FullTimeScore() {
	const event = useContext(ResultsEventContext);

	if (!event.fullTime) {
		return <td className="table--results__body__data">-</td>;
	}

	return (
		<td className="table--results__body__data table--results__body__data--score">
			{event.fullTime.home}:{event.fullTime.away}
		</td>
	);
};

const ScorePerPeriod = function ScorePerPeriod() {
	const result = useContext(ResultsContext);
	const event = useContext(ResultsEventContext);

	if (
		result.scoreType != ScoreType.PERPERIOD &&
		result.scoreType != ScoreType.PERPERIODWITHOT
	) {
		return null;
	}

	if (!event.scorePerPeriod) {
		return <ScorePerPeriodEmptySpaces />;
	}

	return (
		<>
			<ScorePerPeriodList />
			<ScorePerPeriodEmptySpaces />
		</>
	);
};

const ScorePerPeriodList = function ScorePerPeriodList() {
	const event = useContext(ResultsEventContext);

	return (
		<>
			{event.scorePerPeriod?.map((period, idx) => {
				return (
					<td
						key={`${event.id}-spp-${idx}`}
						className="table--results__body__data table--results__body__data--period"
					>
						{period.home}:{period.away}
					</td>
				);
			})}
		</>
	);
};

const ScorePerPeriodEmptySpaces = function ScorePerPeriodEmptySpaces() {
	const result = useContext(ResultsContext);
	const event = useContext(ResultsEventContext);

	if (
		event.scorePerPeriod &&
		event.scorePerPeriod.length > result.columnsCount
	) {
		return null;
	}

	const difference =
		result.columnsCount - (event.scorePerPeriod?.length || 0);
	return (
		<>
			{range(difference).map((item, idx) => {
				return (
					<td
						key={`${event.id}-spp-empty-${idx}`}
						className="table--results__body__data table--results__body__data--period"
					>
						-
					</td>
				);
			})}
		</>
	);
};

const HalfTimeScore = function HalfTimeScore() {
	const result = useContext(ResultsContext);
	const event = useContext(ResultsEventContext);

	if (
		result.scoreType === ScoreType.HEAD2HEAD ||
		result.scoreType === ScoreType.HEAD2HEADWITHOT
	) {
		if (event.halfTime) {
			return (
				<td className="table--results__body__data table--results__body__data--ht">
					{event.halfTime.home}:{event.halfTime.away}
				</td>
			);
		} else {
			return <td className="table--results__body__data">-</td>;
		}
	}

	return null;
};

const OverTimeScore = function OverTimeScore() {
	const event = useContext(ResultsEventContext);

	if (!event.overTimeScore) {
		return null;
	}

	return (
		<td className="table--results__body__data table--results__body__data--otap">
			{event.overTimeScore.home}:{event.overTimeScore.away}{" "}
			{event.penalties != null
				? `(${event.penalties.home}:${event.penalties.away})`
				: ""}
		</td>
	);
};

const OverTimeEmpty = function OverTimeEmpty() {
	const result = useContext(ResultsContext);
	const event = useContext(ResultsEventContext);

	if (
		!event.overTimeScore &&
		(result.scoreType === ScoreType.PERPERIODWITHOT ||
			result.scoreType === ScoreType.HEAD2HEADWITHOT ||
			result.scoreType === ScoreType.FTONLYWITHOT)
	) {
		return <td className="table--results__body__data">-</td>;
	}

	return null;
};
